/**
 * Garment measurement form:
 * - Show/hide when variant option matches (e.g. "Custom").
 * - On add to cart: only send measurement properties when Custom is selected; otherwise only variant goes.
 */
(function () {
  function isVariantOptionMatch(variant, showWhenValue) {
    if (!variant || !showWhenValue) return false;
    const val = String(showWhenValue).trim().toLowerCase();
    const o1 = (variant.option1 || '').trim().toLowerCase();
    const o2 = (variant.option2 || '').trim().toLowerCase();
    const o3 = (variant.option3 || '').trim().toLowerCase();
    return o1 === val || o2 === val || o3 === val;
  }

  function initShowHide() {
    const wrappers = document.querySelectorAll('.garment-measurement-form-wrapper[data-show-when-option-value]');
    if (!wrappers.length || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    wrappers.forEach(function (wrapper) {
      const showWhen = (wrapper.getAttribute('data-show-when-option-value') || '').trim();
      if (!showWhen) return;

      const sectionId = wrapper.getAttribute('data-section-id');

      function setMeasurementRequired(required) {
        var inputs = wrapper.querySelectorAll('input[name^="properties["], select[name^="properties["]');
        inputs.forEach(function (inp) {
          if (required) inp.setAttribute('required', '');
          else inp.removeAttribute('required');
        });
      }

      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (sectionId && event.data?.sectionId && String(event.data.sectionId) !== String(sectionId)) return;
        if (!wrapper.isConnected) return;
        const variant = event.data?.variant;
        const show = isVariantOptionMatch(variant, showWhen);
        wrapper.classList.toggle('garment-measurement-form-wrapper--hidden', !show);
        setMeasurementRequired(show);
      });

      if (wrapper.classList.contains('garment-measurement-form-wrapper--hidden')) setMeasurementRequired(false);
    });
  }

  var submitStripBound = false;
  function initSubmitStrip() {
    if (submitStripBound) return;
    submitStripBound = true;
    document.addEventListener('submit', function (evt) {
      const form = evt.target;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

      const productInfo = form.closest('product-info');
      if (!productInfo) return;

      const wrappers = productInfo.querySelectorAll('.garment-measurement-form-wrapper[data-show-when-option-value]');
      if (!wrappers.length) return;

      var variantEl = productInfo.querySelector('variant-selects [data-selected-variant]');
      var variant = null;
      try {
        if (variantEl && variantEl.textContent) variant = JSON.parse(variantEl.textContent);
      } catch (e) {}

      var visibleWrappers = [];
      for (var w = 0; w < wrappers.length; w++) {
        var wShowWhen = (wrappers[w].getAttribute('data-show-when-option-value') || '').trim();
        if (wShowWhen && isVariantOptionMatch(variant, wShowWhen)) {
          visibleWrappers.push(wrappers[w]);
        }
      }
      var isCustom = visibleWrappers.length > 0;

      if (isCustom) {
        for (var v = 0; v < visibleWrappers.length; v++) {
          var inputsToValidate = visibleWrappers[v].querySelectorAll('input[name^="properties["], select[name^="properties["]');
          var firstInvalid = null;
          for (var i = 0; i < inputsToValidate.length; i++) {
            var inp = inputsToValidate[i];
            if (!inp.hasAttribute('required')) continue;
            var val = (inp.value || '').trim();
            if (inp.tagName === 'SELECT' && val === '') { firstInvalid = inp; break; }
            if ((inp.type === 'text' || inp.type === 'number' || inp.type === '') && val === '') { firstInvalid = inp; break; }
          }
          if (firstInvalid) {
            evt.preventDefault();
            evt.stopPropagation();
            firstInvalid.focus();
            var errWrap = form.querySelector('.product-form__error-message-wrapper');
            var errMsg = form.querySelector('.product-form__error-message');
            if (errWrap && errMsg) {
              errWrap.hidden = false;
              errMsg.textContent = 'Please fill all measurement fields.';
            }
            return;
          }
        }
      }

      if (isCustom) return;

      var saved = [];
      for (var s = 0; s < wrappers.length; s++) {
        var inputs = wrappers[s].querySelectorAll('input[name^="properties["], select[name^="properties["]');
        inputs.forEach(function (inp) {
          var n = inp.getAttribute('name');
          if (n) {
            saved.push({ el: inp, name: n, required: inp.hasAttribute('required') });
            inp.removeAttribute('name');
            inp.removeAttribute('required');
          }
        });
      }
      setTimeout(function () {
        saved.forEach(function (s) {
          s.el.setAttribute('name', s.name);
          if (s.required) s.el.setAttribute('required', '');
        });
      }, 0);
    }, true);
  }

  function parseHeightSortKey(text) {
    if (!text || !text.trim()) return 0;
    var m = String(text).trim().match(/^(\d+)\s*ft\s*(?:(\d+)\s*"?)?$/i);
    if (!m) return 0;
    var feet = parseInt(m[1], 10) || 0;
    var inches = parseInt(m[2], 10) || 0;
    return feet * 12 + inches;
  }

  function sortHeightSelects() {
    var selects = document.querySelectorAll('select[name="properties[Your Height (with heels)]"]');
    selects.forEach(function (select) {
      var options = Array.prototype.slice.call(select.options);
      if (options.length <= 1) return;
      var first = options[0];
      var rest = options.slice(1);
      rest.sort(function (a, b) {
        var keyA = parseHeightSortKey(a.textContent || a.value);
        var keyB = parseHeightSortKey(b.textContent || b.value);
        return keyA - keyB;
      });
      rest.forEach(function (opt) { opt.remove(); });
      rest.forEach(function (opt) { select.appendChild(opt); });
    });
  }

  function init() {
    initShowHide();
    initSubmitStrip();
    sortHeightSelects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('product-info:loaded', function () {
    initShowHide();
    sortHeightSelects();
  });
})();
